import {useEffect, useState} from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {ID, KTCard, KTIcon} from '../../../../../_metronic/helpers'
import {GetDocumentRequestResponse, DocumentRequest, ProposalsDocRequest} from './core/_models'
import DocumentRequestPageHeader from './DocumentRequestPageHeader'
import DocumentRequestPageList from './DocumentRequestPageList'
import {CreateAppModal} from './create-app-stepper/CreateAppModal'
import Pagination from '../../../../components/Pagination'
import readXlsxFile from 'read-excel-file'
import {Proposal} from '../proposals/core/_models'
import {createSolicitationDocument, getProposals} from '../proposals/core/_requests'

const protocolBreadcrumbs: Array<PageLink> = [
  {
    title: 'DocumentRequests',
    path: '/apps/document-requests/list',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DocumentRequestPage = () => {
  const [openFormModal, setOpenFormModal] = useState<boolean>(false)
  const [openDeleteFormModal, setOpenDeleteFormModal] = useState<boolean>(false)
  const [idDocumentRequest, setIdDocumentRequest] = useState<ID>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [documentRequests, setDocumentRequests] = useState<GetDocumentRequestResponse>({
    data: [],
    limite: 10,
    pagina: 1,
    total: 0,
  })
  const [protocol, setDocumentRequest] = useState<DocumentRequest>({})
  const [selectedProposals, setSelectedProposals] = useState<ProposalsDocRequest[]>([])

  //ler xlsx
  const handleFile = async (e: any) => {
    const file = e.target.files[0]
    const rows = await readXlsxFile(file)

    //remover primeiro item do array
    rows.shift()

    console.log(rows)

    const proposalsToRequest: ProposalsDocRequest[] = []

    for await (const row of rows) {
      const [numero, tipo, urgente] = row

      const proposal: ProposalsDocRequest = {
        numeroProposta: numero.toString(),
        tipoProposta: tipo.toString(),
        urgente: urgente.toString(),
        waiting: true,
        founded: false,
      }

      proposalsToRequest.push(proposal)
    }

    setSelectedProposals([...proposalsToRequest])
  }

  const handleSolicitation = async () => {
    const updatedSelectedProposals = selectedProposals

    for await (const proposal of selectedProposals) {
      const p = await getProposals({numeroProposta: proposal.numeroProposta}, 1, 1)

      //encontrar proposta no selectedProposals e atualizar como não localizada na base
      const index = selectedProposals.findIndex((p) => p.numeroProposta === proposal.numeroProposta)
      updatedSelectedProposals[index].waiting = false

      if (p.data.length === 0) {
        console.log('Proposta não encontrada')

        updatedSelectedProposals[index].founded = false

        continue
      }

      updatedSelectedProposals[index].founded = true

      await createSolicitationDocument({
        proposta: p.data[0].id,
        tipo: proposal.tipoProposta,
        urgente: proposal.urgente,
        dataSolicitacao: new Date(),
      })
    }

    setSelectedProposals([...updatedSelectedProposals])
  }

  const handleList = async (pagina: number = 1, limite: number = 10, query?: string) => {
    setIsLoading(true)
    // const protocolList = await getDocumentRequests(pagina, limite, query)
    // setDocumentRequests(protocolList)
    setIsLoading(false)
  }

  const handleFormModal = (isEmptyModal: boolean = false) => {
    if (isEmptyModal) {
      setDocumentRequest({})
    }

    setOpenFormModal(!openFormModal)
  }

  useEffect(() => {
    handleList()
  }, [])

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <KTCard>
                <PageTitle breadcrumbs={protocolBreadcrumbs}>
                  Solicitação em massa de propostas
                </PageTitle>
                <div className='card-header border-0 pt-6'>
                  <input type='file' onChange={handleFile} />
                  <button
                    type='button'
                    className='btn btn-light-primary me-3'
                    onClick={handleSolicitation}
                  >
                    <KTIcon iconName='exit-up' className='fs-2' />
                    Enviar
                  </button>
                </div>

                <div className='card-body'>
                  <div className='d-flex align-items-center position-relative my-1'>
                    <table className='table table-hover table-rounded table-striped border gy-7 gs-7'>
                      <thead>
                        <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
                          <th>Proposta</th>
                          <th>Tipo</th>
                          <th>Urgente?</th>
                          <th>Status da solicitação</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedProposals.length > 0 ? (
                          selectedProposals.map((proposal) => (
                            <tr
                              style={{
                                background: !proposal.founded && !proposal.waiting ? '#F00' : 'FFF',
                              }}
                            >
                              <td>{proposal.numeroProposta}</td>
                              <td>{proposal.tipoProposta}</td>
                              <td>{proposal.urgente}</td>
                              <td>
                                {!proposal.founded &&
                                  !proposal.waiting &&
                                  'Proposta não encontrada na base'}

                                {proposal.founded && !proposal.waiting && 'Solicitação enviada'}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={4}></td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* <DocumentRequestPageHeader
                  handleFormModal={handleFormModal}
                  handleList={handleList}
                />
                <DocumentRequestPageList
                  handleFormModal={handleFormModal}
                  handleById={handleById}
                  handleDelete={handleDeleteModal}
                  documentRequests={documentRequests}
                  isLoading={isLoading}
                />
                <Pagination handleList={handleList} {...documentRequests} /> */}
              </KTCard>
              {openFormModal && (
                <CreateAppModal handleClose={handleFormModal} show={openFormModal} />
              )}
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/document-requests/list' />} />
    </Routes>
  )
}

export default DocumentRequestPage
